import { QUESTIONS_ROUTES } from '../../constants/_routes'
import questionsTypes from '../../constants/questionsTypes'
import { axios } from '../../services'
import { current_timestamp } from '../../helpers'

// INDEX
const questions_index_request = () => {
  return {
    type: questionsTypes.index.request
  }
}

const questions_index_success = (response) => {
  return {
    type: questionsTypes.index.success,
    payload: response.data
  }
}

const questions_index_failure = (messages) => {
  return {
    type: questionsTypes.index.failure,
    payload: messages
  }
}

const questions_index = (page=1, per_page=10, filters={}, sort="", order="") => {
  return function (dispatch) {
    // Before Request
    dispatch(questions_index_request())

    // Request
    axios.get(
      QUESTIONS_ROUTES.index,
      {
        params: {
          page: page,
          per_page: per_page,
          sort: sort,
          order: order,
          filters: filters,
          serial: current_timestamp()
        }
      }
    ).then( response => {
      // success
      dispatch( questions_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching questions."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( questions_index_failure(errors))
    })
  }

}

export {
  questions_index
}



// WEBPACK FOOTER //
// ./src/js/actions/questions/getindex.js